import { ROLE_TYPE } from "@supplier/meta";
import { UserStore } from "@/stores/user";
import tradeContractRouters from "@/routers/tradeManagement/contractManagement";
import tradeReconciliationRouters from "@/routers/tradeManagement/reconciliation";
import { hasTradePermission } from "@/utils/permission";
import { AccountStore } from "@/stores/account";

export const tradeManagementRouters = [
    {
        path: "/tradeManagement",
        name: "TradeManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/tradeManagement/tradeContract",
        meta: {
            title: "贸易业务",
            icon: "icon-maoyiyewu",
            auth: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                // SAAS 环境下无权限
                if (userStore.isSAAS) {
                    return false;
                }
                if (accountStore.isSubAccount) {
                    return hasTradePermission(userStore.userInfo.permissions);
                }
                return !!userStore.userInfo?.customer?.roles?.includes(ROLE_TYPE.TRADE_CUSTOMER.code);
            }
        },
        children: [...tradeContractRouters, ...tradeReconciliationRouters]
    }
];
